// Module
var code = "<span raw-html=\"currentRow.fullResponse\"></span> ";
// Exports
module.exports = code;